<template>
	<div class="account-feedback">
		<h2>Feedback</h2>
    <form class="feedback-wrap">
      <div class="feedback-type">
        <span class="subtitle">Feedback Type</span>
        <div class="feedback-options">
          <label class="custom-check">
            <input type="radio" value="COMMENT" name="feedback-type"/>
            <span class="checkmark"></span>
            <p>Comments</p>
          </label>
          <label class="custom-check">
            <input type="radio" value="SUGGESTION" name="feedback-type" checked/>
            <span class="checkmark"></span>
            <p>Suggestions</p>
          </label>
          <label class="custom-check">
            <input type="radio" value="QUESTION" name="feedback-type"/>
            <span class="checkmark"></span>
            <p>Questions</p>
          </label>
        </div>
      </div>
      <div class="feedback">
        <span class="subtitle">Describe Your Feedback</span>
        <textarea id="message"
          v-model="stringLength"
          v-on:keyup="calculateStringLength"
          placeholder="Write your feedback here">
        </textarea>
        <span class="user-msgs">initial message</span>
        <div class="subform">
          <p> <span> 0 </span> /500 characters </p>
          <button type="button" class="orange-btn" @click='submitFeedback'>Submit</button>
        </div>
      </div>
    </form>
	</div>
</template>

<script lang="ts">
import {axiosClient} from '../../../axios-client';

export default {
  name: 'feedback',
  data() {
    return {
      stringLength: '',
    }
  },
  methods: {
    calculateStringLength() {
      document.querySelector('.subform p span').innerHTML = this.stringLength.length;

      if(this.stringLength.length >= 500) {
        document.querySelector('textarea#message').style.border = '1px solid red';
        document.querySelector('.subform p span').style.color = 'red';
      } else {
        document.querySelector('textarea#message').style.border = '1px solid #cdcdcd';
        document.querySelector('.subform p span').style.color = '#676868';
      }
    },

    submitFeedback() {
      let message = document.querySelector('textarea#message').value;
      let radioValue = document.querySelector('.feedback-options input:checked').value;
      let successMessage = document.querySelector('form.feedback-wrap .user-msgs');

      if(message.length < 500 && message.length != 0) {
        axiosClient.post('v1/feedback', {
        text: message,
        feedbackType: radioValue
      })
        .then(() => {
          successMessage.innerHTML = 'Your Feedback has been reported. Thank you for submiting.';
          successMessage.style.visibility = 'initial';
        })
        .catch(() => {
          successMessage.innerHTML = 'Unexpected error';
          successMessage.style.visibility = 'hidden';
        })
      } else {
        successMessage.innerHTML = 'Maximum message characters is 500.';
        successMessage.style.visibility = 'initial';
      }
    }
  }
}
</script>

<style lang="scss">
  .account-feedback {
    padding: 50px;
    display: none;

    h2 {
      font-family: "Roboto-Medium";
      margin-bottom: 30px;
    }

    form.feedback-wrap {
      display: flex;
      justify-content: space-between;

      span.subtitle {
        font-size: 14px;
        line-height: 22px;
        color: #676868;
        display: block;
        margin-bottom: 8px;
        font-family: "Gotham-Book";
      }

      .user-msgs {
        visibility: hidden;
        font-size: 12px;
        color: #F26464;
      }

      .feedback-type {
        .feedback-options {
          min-height: 140px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-top: 15px;

          .custom-check {
            p {
              padding-left: 35px;
              margin: 0;
            }

            .checkmark {
              top: 4px;
              border-radius: 100%;
            }
          }
        }
      }

      .feedback {
        width: 100%;
        padding-left: 5%;

        textarea {
          width: 100%;
          resize: none;
          border: 1px solid #CDCDCD;
          border-radius: 5px;
          padding: 16px 20px;
          min-height: 150px;
          font-family: "Gotham-Book";
          font-size: 14px;
          color: #676868;

          &:focus {
            outline: none;
          }
        }

        .subform {
          display: flex;
          justify-content: space-between;
          margin-top: 10px;

          p {
            font-size: 14px;
            line-height: 160%;
            color: #676868;
            display: inline-flex;
          }

          button {
            border: none;
            width: 200px;
          }
        }
      }
    }
  }
</style>